import React, { useEffect, useState } from "react";
import { Form, Spinner } from "react-bootstrap";
import { useForm } from "react-hook-form";
import OTPInput from "react-otp-input";
import { useNavigate } from "react-router-dom";
import { ThemeButton } from "../components/ThemeComponent/ThemeButtons";
import {
    AuthHeadingText,
    SimpleBasic,
    TextBasic,
} from "../components/ThemeComponent/ThemeText";
import { useForgotOtpMutation } from "../Redux/services/userAuthApi.js";
import ThemeSpinner from "../components/ThemeComponent/ThemeSpinner";
import { errorToast, success } from "../utils/helpers.js";
import { useSelector } from "react-redux";
import { storeAuthToken } from "../Redux/services/localStorageService.js";

export default function OTPVerification() {
  const {
    handleSubmit,
    control,
    formState: { errors },
  } = useForm();
  const navigate = useNavigate();
  const [otp, setOtp] = useState("");
  const [timer, setTimer] = useState("48");
  const [isLoadingResend, setIsApiLoading] = useState(false);

  const [forgotOtp, { isLoading }] = useForgotOtpMutation();
  const user = useSelector(state => state.authInfo.user);

  const onSubmit = async (data) => {
    try {
      let payload = {
        "email": user?.email,
        "otp": otp,
      }
      const response = await forgotOtp(payload).unwrap();

      console.log(response);

      if (response.code === 200) {
        storeAuthToken(response.data.api_token)
        success(response?.message || "OtP Verified Successfully");
        navigate("/set-new-password");
      }
    } catch (error) {
      if (error?.response && error?.response?.data?.message) {
        errorToast(error?.response?.data?.message, "error");
      } else {
        errorToast("An error occurred during login", "error");
      }
    }
  };

  const handleResend = async () => {};

  useEffect(() => {
    let interval;
    if (timer > 0) {
      interval = setInterval(() => {
        setTimer((prev) => prev - 1);
      }, 1000);
    }

    return () => {
      clearInterval(interval);
    };
  }, [timer]);

  return (
    <div className="login w-100">
      <AuthHeadingText text="OTP Verification" className="w-100 mb-2 fw-700" />
      <SimpleBasic
        text="Please enter 6-digit code we have sent you on your email"
        className="w-100 mt-1 mb-3"
      />

      <Form onSubmit={handleSubmit(onSubmit)}>
        <div className="otp-input mb-5 d-flex justify-content-between align-items-center">
          <OTPInput
            value={otp}
            onChange={setOtp}
            numInputs={6}
            renderInput={(props) => <input {...props} placeholder="" />}
            //   renderInput={(props) => <input {...props} />}
          />
        </div>
        {!isLoadingResend ? (
          <div className="d-flex justify-content-center align-items-center mt-4">
            <div className="resend-otp cursor rounded-pill py-3 w-50 text-center" onClick={handleResend}>
              {!isLoadingResend ? <TextBasic text={`Resend in 00:${timer}`} className={"fw-semibold"} /> : <Spinner />}
            </div>
          </div>
        ) : (
          <Spinner />
        )}
        <ThemeButton
          text={isLoading ? <ThemeSpinner /> : "Continue"}
          className="mt-4 mb-2 fw-bold w-100 mt-3"
          type="submit"
          onClick={handleSubmit(onSubmit)}
        />
      </Form>
    </div>
  );
}
